import { useCallback, useState } from "react";
import { copyText } from "@/utils/clipboard";

export default function DnsCopyBtn({ value, label = "Copy" }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = useCallback(async () => {
    const ok = await copyText(value);
    if (!ok) return;
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  }, [value]);

  return (
    <button
      type="button"
      className="btn s3WizMiniBtn s3WizDnsCopyBtn"
      onClick={() => { void handleCopy(); }}
      aria-label={`Copy ${value}`}
    >
      {copied ? "Copied" : label}
    </button>
  );
}
